import script from "./purchaseList.vue?vue&type=script&setup=true&name=purchaseList&lang=js"
export * from "./purchaseList.vue?vue&type=script&setup=true&name=purchaseList&lang=js"

const __exports__ = script;

export default __exports__